export default "__VITE_ASSET__CkNiI210__"